import React from 'react';

import { Navigate, type RouteObject } from 'react-router-dom';

import {
  ACCOUNT_ITSM_INTEGRATIONS_ROUTE,
  ACTIVE_RESPONSE,
  ALLOW_LIST_REQUIREMENTS_ROUTE,
  CONTACT_CONCIERGE_ROUTE,
  COVERAGE_SCORE_ROUTE,
  EVENT_LOG_SEARCH_ROUTE,
  SCHEDULED_REPORTS_ROUTE,
  TELEMETRY_LOG_SOURCES_ROUTE,
} from 'ae-constants/routes.constants';

type Redirection = [oldUrl: string, newUrl: string];

const redirectionList: Redirection[] = [
  ['/allowlist', ALLOW_LIST_REQUIREMENTS_ROUTE],
  ['/contact', CONTACT_CONCIERGE_ROUTE],
  ['/data-explorer/logins-events', EVENT_LOG_SEARCH_ROUTE],
  ['/data-explorer/logins/events', EVENT_LOG_SEARCH_ROUTE],
  ['/scheduled-reports', SCHEDULED_REPORTS_ROUTE],
  ['/logins-by-country', EVENT_LOG_SEARCH_ROUTE],
  ['/data-explorer/logins-by-country', EVENT_LOG_SEARCH_ROUTE],
  ['/data-explorer/logins/events', EVENT_LOG_SEARCH_ROUTE],
  ['/account/log-sources', TELEMETRY_LOG_SOURCES_ROUTE],
  ['/coverage-score', COVERAGE_SCORE_ROUTE],
  ['/account/itsm-integrations', ACCOUNT_ITSM_INTEGRATIONS_ROUTE],
  ['/account/active-response', ACTIVE_RESPONSE],
];

export const redirectionRoutes = redirectionList.map<RouteObject>(
  ([from, to]) => {
    return {
      element: <Navigate to={to} />,
      path: from,
    };
  },
);
